import {Route, Routes} from "react-router-dom";

import {API_ENDPOINTS} from "../api/endpoints";
import AccessBoundary from "../Components/AccessBoundary/AccessBoundary";
import GoodsReceivingWarehouse from "../Components/Warehouse/GoodsReceivingWarehouse/GoodsReceivingWarehouse";
import ReqForPlanningRegisterWarehouse from "../Components/Warehouse/ReqForPlanningRegisterWarehouse/ReqForPlanningRegisterWarehouse";
import WarehouseInventory from "../Components/Warehouse/WarehouseInventory/WarehouseInventory";
import WarehouseSettings from "../Components/Warehouse/WarehouseSettings/WarehouseSettings";

const WarehousePage = () => {
  return (
    <Routes>
      <Route
        path={API_ENDPOINTS.WAREHOUSE.REQUESTS_FOR_PLANNING_REGISTER}
        element={
          <AccessBoundary itManagerOnly>
            <ReqForPlanningRegisterWarehouse />
          </AccessBoundary>
        }
      />
      <Route
        path={API_ENDPOINTS.WAREHOUSE.WAREHOUSE_INVENTORY_ORDER_CO}
        element={
          <AccessBoundary itManagerOnly>
            <WarehouseInventory orderCO />
          </AccessBoundary>
        }
      />
      <Route
        path={API_ENDPOINTS.WAREHOUSE.WAREHOUSE_INVENTORY_RETAIL}
        element={
          <AccessBoundary itManagerOnly>
            <WarehouseInventory retail />
          </AccessBoundary>
        }
      />
      <Route
        path={API_ENDPOINTS.WAREHOUSE.GOODS_RECEIVING_WAREHOUSE}
        element={
          <AccessBoundary itManagerOnly>
            <GoodsReceivingWarehouse />
          </AccessBoundary>
        }
      />
      <Route
        path={API_ENDPOINTS.WAREHOUSE.WAREHOUSE_SETTINGS}
        element={
          <AccessBoundary itManagerOnly>
            <WarehouseSettings />
          </AccessBoundary>
        }
      />
    </Routes>
  );
};

export default WarehousePage;
